/**
 * @url /systemerror
 * @CONST CONST.URL_SYSTEM_ERROR
 * @menu 없음
 * @mapping 서비스 점검 화면
 */
import React from "react";
// css
import "/static/css/style.css";
import "/static/css/content.css";
// component
import Header from "../header/Header";
import SystemError from "../common/systemerror/SystemError";
function SystemErrorLayout() {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "wrap" },
            React.createElement(Header, null),
            React.createElement(SystemError, null))));
}
export default SystemErrorLayout;
